export var SEASON_PREVIEW_LAST_SEASON_KEY = 'salesbook:lastSeasonCode';
export var SEASON_PREVIEW_IMAGE_MAP_KEY = 'IMAGE_MAP_PACKS_V6';
export var SEASON_PREVIEW_SHARD_CACHE_PREFIX = 'molo:seasonPreviewShard:';
//# sourceMappingURL=constants.js.map